import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Course } from "src/app/_models/Course";
import { CourseCategory } from "src/app/_models/CourseCategory";
import { CourseActionTypes } from "src/app/constants/StoreConstants";

export const GetCourses = createAction(
  CourseActionTypes.GetCourses
);

export const GetCoursesSuccess = createAction(
  CourseActionTypes.GetCoursesSuccess,
  props<{result: Course[]}>()
);

export const GetCoursesError = createAction(
  CourseActionTypes.GetCoursesError,
  props<{error: HttpErrorResponse}>()
);

export const GetCourseById = createAction(
  CourseActionTypes.GetCourseById,
  props<{courseId: number}>()
);

export const GetCourseByIdSuccess = createAction(
  CourseActionTypes.GetCourseByIdSuccess,
  props<{course: Course}>()
);

export const GetCourseByIdError = createAction(
  CourseActionTypes.GetCourseByIdError,
  props<{error: HttpErrorResponse}>()
);

export const GetCategoriesByCourseId = createAction(
  CourseActionTypes.GetCategoriesByCourseId,
  props<{courseId: number}>()
);

export const GetCategoriesByCourseIdSuccess = createAction(
  CourseActionTypes.GetCategoriesByCourseIdSuccess,
  props<{categories: CourseCategory[]}>()
);

export const GetCategoriesByCourseIdError = createAction(
  CourseActionTypes.GetCategoriesByCourseIdError,
  props<{error: HttpErrorResponse}>()
);